// extracted by mini-css-extract-plugin
export var buttonContainer = "_9s-1";
export var fontSizeSelect = "_9s-3";
export var formatSelect = "_9s-2";
export var formats = "_9s-4";
export var hidden = "_9s-5";
export var icon = "_9s-6";
export var select = "_9s-0";